import React from 'react';
import { Card, CardContent } from '../ui/card';

interface BaselineKPICardsProps {
  data: {
    baseYear: {
      total: number;
    };
    selectedYear: {
      total: number;
    };
    baseYearValue: number;
    selectedYearValue: number;
  } | undefined;
}

export function BaselineKPICards({ data }: BaselineKPICardsProps) {
  if (!data) return null;

  const totalVariance = data.selectedYear.total - data.baseYear.total;
  const variancePercent = data.baseYear.total > 0 ? (totalVariance / data.baseYear.total) * 100 : 0;
  const isImprovement = totalVariance < 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Base Year KPI */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Base Year ({data.baseYearValue})</p>
              <p className="text-2xl font-bold text-blue-600">
                {data.baseYear.total.toFixed(2)}
              </p>
              <p className="text-xs text-gray-500">kg CO2e</p>
            </div>
            <i data-feather="calendar" className="w-8 h-8 text-blue-400"></i>
          </div>
        </CardContent>
      </Card>

      {/* Selected Year KPI */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Selected Year ({data.selectedYearValue})</p>
              <p className="text-2xl font-bold text-green-600">
                {data.selectedYear.total.toFixed(2)}
              </p>
              <p className="text-xs text-gray-500">kg CO2e</p>
            </div>
            <i data-feather="target" className="w-8 h-8 text-green-400"></i>
          </div>
        </CardContent>
      </Card>

      {/* Variance KPI */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Variance</p>
              <p className={`text-2xl font-bold ${isImprovement ? 'text-green-600' : 'text-red-600'}`}>
                {isImprovement ? '' : '+'}{totalVariance.toFixed(2)}
              </p>
              <p className="text-xs text-gray-500">
                {isImprovement ? '' : '+'}{variancePercent.toFixed(1)}% vs baseline
              </p>
            </div>
            <i 
              data-feather={isImprovement ? 'trending-down' : 'trending-up'} 
              className={`w-8 h-8 ${isImprovement ? 'text-green-400' : 'text-red-400'}`}
            ></i>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}



